
























import externalComponent from './utils/external-component';
import {Vue, Component, Prop, Watch} from "vue-property-decorator";
import {SDynamicComponent} from '@/components/dto/SDynamicComponent';
import {SComponentIdentity} from "@/components/dto/SComponentIdentity";
import {ScomponentMode} from "@/components/dto/ScomponentMode";
@Component
export default class DynamicComponent extends Vue {
    @Prop() props!: SDynamicComponent;
    @Prop() formData!: any;
    private computedComponent:any = null;
    private hover:boolean = false;

    @Watch('props.component', {immediate: true})
    onPropertyChanged(newComponent:SComponentIdentity, prevComponent:SComponentIdentity = {uid:'', name:'', url:''}) {
        if (prevComponent.url === newComponent.url) return;
        externalComponent(this.props.component.url)
            .then(com =>{
                this.computedComponent = com;
            });
    }

    removeComponent(){
        this.handle_function_call('removeComponent', this.props.component.uid);
    }
    openComponentSettings(){
        this.handle_function_call('openComponentSettings', this.props);
    }

    handle_function_call(e:any, param:any) {
        this.$emit('callfunction', e, param);
    }

}
